import {Activity} from 'lucide-react'
import { Link } from 'react-router-dom'
import type { ColonyFeedItem } from '@/lib/colonyFeed'
import { formatCurrency, formatRelativeTime } from '@/lib/format'
import { tokenSharePath } from '@/lib/shareSlug'

const kindCopy: Record<ColonyFeedItem['kind'], { label: string, className: string }> = {
  buy: { label: 'bought', className: 'text-lime-400' },
  sell: { label: 'sold', className: 'text-orange-400' },
  contribute: { label: 'contributed', className: 'text-orange-300' },
}

interface ColonyFeedProps {
  items: ColonyFeedItem[]
  title?: string
  emptyLabel?: string
}

function ColonyFeed({ items, title = 'Colony pulse', emptyLabel = 'No recent colony activity yet.' }: ColonyFeedProps) {
  return (
    <div className="rounded-3xl border border-white/10 bg-white/[0.03] p-5 backdrop-blur-md">
      <div className="flex items-center gap-2">
        <Activity className="h-4 w-4 text-lime-400" aria-hidden="true" />
        <h2 className="text-sm font-semibold text-white">{title}</h2>
      </div>

      {items.length > 0
        ? (
            <ul className="mt-4 divide-y divide-white/5">
              {items.map((item) => {
                const href = tokenSharePath(item.shareSlug, item.projectId)
                const copy = kindCopy[item.kind]
                return (
                  <li key={item.id} className="py-3 first:pt-0 last:pb-0">
                    <Link to={href} className="flex items-start justify-between gap-3 hover:opacity-90">
                      <div className="min-w-0">
                        <p className="truncate text-sm text-zinc-300">
                          <span className="font-mono text-xs text-zinc-500">{item.wallet}</span>
                          {' '}
                          <span className={copy.className}>{copy.label}</span>
                          {' '}
                          {formatCurrency(item.amountUsd)}
                          {' '}
                          into
                          {' '}
                          <span className="font-semibold text-white">${item.ticker}</span>
                        </p>
                        <p className="mt-0.5 truncate text-[11px] text-zinc-600">{item.projectName}</p>
                      </div>
                      <span className="shrink-0 text-[11px] text-zinc-600">{formatRelativeTime(item.createdAt)}</span>
                    </Link>
                  </li>
                )
              })}
            </ul>
          )
        : (
            <p className="mt-4 text-sm text-zinc-500">{emptyLabel}</p>
          )}
    </div>
  )
}

export default ColonyFeed
